export default __webpack_public_path__ + "static/media/avatar07.517fe7da.svg";